import React, { createContext, useContext } from 'react';

const IsLandingSectionContext = createContext();

export function useIsLandingSection() {
    return useContext(IsLandingSectionContext);
}

export default function LandingSectionProvider(props) {
    return (
        <IsLandingSectionContext.Provider value={true}>
            {props.children}
        </IsLandingSectionContext.Provider>
    );
}
